import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, flow, observable, runInAction } from "mobx";
import { routeLocationLicenseActivationDelete } from "@devowl-wp/api-real-commerce";
import { RealCommerceError } from "../exceptions/realCommerceError.js";
import { __ } from "../utils/i18n.js";
import { realCommerceRequest } from "../utils/realCommerceRequest.js";
const CONNECT_LOST_MILLISECONDS = 3 * 24 * 60 * 60 * 1000;
class LicenseActivation {
    get host() {
        return this.data?.client.properties.filter(({ key })=>key === "hostname")[0]?.value;
    }
    get pluginVersion() {
        return this.data?.properties.filter(({ key })=>key === "pluginVersion")[0]?.value || __("Unknown");
    }
    get lastSeen() {
        const lastSeen = this.data?.client.properties.filter(({ key })=>key === "lastSeen")[0]?.value;
        return lastSeen ? new Date(lastSeen) : undefined;
    }
    get isConnectionLost() {
        const now = Date.now();
        const { lastSeen } = this;
        return lastSeen ? now - lastSeen.getTime() > CONNECT_LOST_MILLISECONDS : false;
    }
    get session() {
        return this.store.store;
    }
    constructor(data, store){
        this.busy = false;
        this.delete = flow(function*() {
            this.busy = true;
            yield this.session.probablyRenewJwt();
            try {
                const { data: { license: { licenseKey }, client: { uuid } } } = this;
                yield realCommerceRequest({
                    location: routeLocationLicenseActivationDelete,
                    request: {
                        licenseActivation: {
                            license: {
                                licenseKey
                            },
                            client: {
                                uuid
                            }
                        }
                    },
                    settings: {
                        headers: this.session.authorizationHeader
                    }
                });
                yield this.session.fetchLicenses();
                this.store.fetchActivations();
            } catch (e) {
                console.log(e);
                throw new RealCommerceError(e);
            } finally{
                this.busy = false;
            }
        });
        this.store = store;
        runInAction(()=>{
            this.data = data;
        });
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], LicenseActivation.prototype, "data", void 0);
_ts_decorate([
    observable
], LicenseActivation.prototype, "busy", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], LicenseActivation.prototype, "host", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], LicenseActivation.prototype, "pluginVersion", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], LicenseActivation.prototype, "lastSeen", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], LicenseActivation.prototype, "isConnectionLost", null);
export { LicenseActivation };
